/** @jsxImportSource @emotion/react */
import { css, SerializedStyles } from '@emotion/react';

import { styleguideColors as COLORS } from '@/Client/Styles/kaiShikiTokens';

export type SideDrawerStyles = {
  /** The panel itself, pinned to the right edge of its positioned container. */
  root: SerializedStyles;
  header: SerializedStyles;
  /** Everything in the header except the close button: the caller's `header` content. */
  headerContent: SerializedStyles;
  closeButton: SerializedStyles;
  /** The caller's children - the one region that scrolls. */
  body: SerializedStyles;
  footer: SerializedStyles;
};

export const DEFAULT_SIDE_DRAWER_STYLES: SideDrawerStyles = {
  root: css`
    label: SIDE_DRAWER;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: min(440px, 100%);
    /* Above the workspace's own floating chrome it overlays (the editor's prev/next task buttons sit
       at 60, row kebab menus at 75), below real popovers and modals (filter dropdowns 250, the photo
       manager 400, the left nav 1000, modals 2000+). */
    z-index: 100;
    display: flex;
    flex-direction: column;
    background: ${COLORS.white};
    border-left: 1px solid ${COLORS.stroke};
    box-shadow: -6px 0 16px rgba(26, 26, 26, 0.06);
  `,
  header: css`
    label: SIDE_DRAWER_HEADER;
    flex-shrink: 0;
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 18px 20px 16px 26px;
    border-bottom: 1px solid ${COLORS.stroke};
  `,
  headerContent: css`
    label: SIDE_DRAWER_HEADER_CONTENT;
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
  `,
  closeButton: css`
    label: SIDE_DRAWER_CLOSE;
    flex: 0 0 30px;
    width: 30px;
    height: 30px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid ${COLORS.stroke};
    background: ${COLORS.white};
    color: ${COLORS.midtone};
    cursor: pointer;

    &:hover {
      border-color: ${COLORS.ink};
      color: ${COLORS.ink};
    }
  `,
  body: css`
    label: SIDE_DRAWER_BODY;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 20px 20px 20px 26px;
  `,
  footer: css`
    label: SIDE_DRAWER_FOOTER;
    flex-shrink: 0;
    padding: 16px 20px 18px 26px;
    border-top: 1px solid ${COLORS.stroke};
  `,
};
